export default {
  base: {
    backgroundColor: '#89ab2a'
  }
};